import { getRCSPartnerErrorsLogs } from "../api/RCSPartnerErrorsLogs";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../../../../Context/AuthContext";
export const useFetchRCSPartnerErrorsLogs = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useMutation({
    mutationKey: ["fetchRCSPartnerErrorsLogs"],
    mutationFn: async (data) => {
       return await getRCSPartnerErrorsLogs({
        token: user.token,
        data: {
          from: data?.from,
          to: data?.to,
          uidpartner: data?.partner

        },
      });
    },
  });
};
